import { MutableRefObject, useEffect } from 'react';

/**
 * Helper to handle reacting to a click outside a given element.
 * Accepts a ref to the element to monitor for clicks outside of it
 * and a function to execute in response.
 */
export const useClickOutside = (
    ref: MutableRefObject<HTMLElement | undefined>,
    handler: (event: MouseEvent) => void,
): void => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Element;
            if (ref.current && target && !ref.current.contains(target)) {
                handler(event);
            }
        };
        window.setTimeout(() => {
            document.removeEventListener('click', handleClickOutside);
            document.addEventListener('click', handleClickOutside);
        }, 0);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref, handler]);
};
